package services.http

import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import it.neckar.lizergy.model.plannerJson
import kotlinx.serialization.DeserializationStrategy

/**
 * Decodes the response body using an explicitly provided [deserializer] and the shared `plannerJson`.
 *
 * #2098: Ktor's `.body()` resolves the serializer reflectively from `TypeInfo`. On Kotlin/JS, in the
 * full planner-ui browser bundle, that resolution returns a non-polymorphic (structure) serializer for
 * sealed `RestResponse` types, so the class discriminator `type` is treated as an unknown key and the
 * decode fails. Passing the compiler-generated `<Response>.serializer()` explicitly bypasses the
 * reflective resolution and decodes correctly.
 */
suspend fun <T> HttpResponse.plannerBody(deserializer: DeserializationStrategy<T>): T {
  return plannerJson.decodeFromString(deserializer, bodyAsText())
}
